import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import {
  ImageIconWrapperStyled,
  RequiredSignStyled,
  RootStyled,
} from './upload-logo-placeholder.styled';
import { Stack, Typography, useTheme } from '@mui/material';
import { PhotoIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';

interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children?: React.ReactNode;
  required: boolean;
}
export const UploadLogoPlaceholder = ({
  children,
  required,
  ...props
}: Props) => {
  const theme = useTheme();
  if (children) return <RootStyled>{children}</RootStyled>;
  return (
    <RootStyled {...props}>
      <Stack alignItems={'center'}>
        <Typography>LOGO</Typography>
      </Stack>
      <ImageIconWrapperStyled>
        <PhotoIcon
          height={IconSize.buttonIcon}
          color={theme.palette.white.main}
        />
      </ImageIconWrapperStyled>
      <RequiredSignStyled color="error">*</RequiredSignStyled>
    </RootStyled>
  );
};
